import React from 'react';
import { Link } from 'react-router-dom';
import { useLandingPage } from './LandingPage/useLandingPage';
import HeroSection from './LandingPage/HeroSection';
import FiltersCard from './LandingPage/FiltersCard';
import TimeSlotGrid from './LandingPage/TimeSlotGrid';
import LegendCard from './LandingPage/LegendCard';

export default function LandingPage() {
  const f = useLandingPage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-600 via-green-700 to-teal-800">
      <HeroSection onLoginClick={() => f.navigate('/auth')} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="mb-6 sm:mb-8">
          <h2 className="text-3xl sm:text-4xl font-black font-heading uppercase mb-2 text-white">
            Check Availability
          </h2>
          <p className="text-base sm:text-lg text-emerald-100">
            View real-time court availability and pricing
          </p>
        </div>

        <FiltersCard
          locations={f.locations}
          selectedLocation={f.selectedLocation}
          onLocationChange={f.handleLocationChange}
          selectedDate={f.selectedDate}
          setSelectedDate={f.setSelectedDate}
          minDate={f.minDate}
          maxDate={f.maxDate}
          isLocationClosed={f.isLocationClosed}
          getOperatingHoursDisplay={f.getOperatingHoursDisplay}
          getBreakInfo={f.getBreakInfo}
        />

        {f.selectedLocation && (
          <TimeSlotGrid
            selectedLocation={f.selectedLocation}
            isLocationClosed={f.isLocationClosed}
            timeSlots={f.timeSlots}
            loading={f.loading}
            availability={f.availability}
            pricing={f.pricing}
            isTimeSlotPast={f.isTimeSlotPast}
            onBook={f.handleBookSlot}
          />
        )}

        <LegendCard />
      </div>

      <div className="bg-primary text-primary-foreground py-8 mt-12">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-sm opacity-75">
            © 2026 SmashZone. Book your badminton and pickleball courts with ease.
          </p>
          <Link to="/terms" className="text-sm opacity-75 hover:opacity-100 transition-opacity">
            Terms and Conditions
          </Link>
        </div>
      </div>
    </div>
  );
}
